// @flow

import React from 'react';
import { MediaQuery } from '@riseart/common';
import { FadeContent } from '@riseart/layout';
import { GridSquare, GridSquareItem } from '@riseart/grid';
import { CardArticle } from '@riseart/article';
import { LocalizedLink } from 'shared_components/i18n/LocalizedLink';
import { UrlAssembler } from 'shared_services/riseart/utils/UrlAssembler';
import { PicturePlaceholder } from 'shared_components/common/artdirection/picture/Picture';
import { extractImageFileFromData } from 'shared_services/riseart/utils/ImageUtils';

import { raScreenXsMax } from '@riseart/antd-provider/dist/website/variables.less';

type Props = {
  items: Array<Object>,
  lazyloadConfig: Object,
};

/**
 * ArtistArticlesList
 *
 * @param {Props} props
 */
export const ArtistArticlesList = ({ items, lazyloadConfig }: Props) =>
  items ? (
    <GridSquare columnCount={2} justify="space-between">
      {items.map(({ id, categories, title, summary, images, slug, type }) => (
        <GridSquareItem key={id} columnCount={2}>
          <CardArticle
            displayStyle={6}
            title={
              <LocalizedLink
                type="light"
                assembler={{
                  handler: UrlAssembler.articleDetail,
                  args: [id, slug, type],
                }}
                title={title}
              >
                {title}
              </LocalizedLink>
            }
            subtitle={
              categories && categories[0] ? (
                <LocalizedLink
                  assembler={{
                    handler: UrlAssembler.articleCategory,
                    args: [categories[0].uri, categories[0].type],
                  }}
                  title={categories[0].name}
                >
                  {categories[0].name}
                </LocalizedLink>
              ) : null
            }
            description={
              <MediaQuery maxWidth={raScreenXsMax}>
                {(raScreenXsMax) => (
                  <FadeContent
                    height={raScreenXsMax ? 'auto' : '80px'}
                    maxHeight={raScreenXsMax ? '150px' : null}
                  >
                    {summary}
                  </FadeContent>
                )}
              </MediaQuery>
            }
          >
            <LocalizedLink
              assembler={{
                handler: UrlAssembler.articleDetail,
                args: [id, slug, type],
              }}
              title={title}
            >
              <PicturePlaceholder
                type="artist.article"
                artDirectionKey="article.main"
                image={extractImageFileFromData.articleImage(images)}
                alt={title}
                lazyload={lazyloadConfig}
              />
            </LocalizedLink>
          </CardArticle>
        </GridSquareItem>
      ))}
    </GridSquare>
  ) : null;
